<template>
    <hc-dialog
        width="720px"
        close="alter-quotes-version"
        :title="title"
        append-to-body
        :before-close="handleClose"
        :visible.sync="dialogVisible"
    >
        <hc-table :data="versions" stripe>
            <hc-table-column prop="version" width="80" label="版本号" />
            <!--<hc-table-column prop="tag" show-overflow-tooltip width="100" label="标签" /> -->
            <hc-table-column label="引擎范围" width="100">
                <template slot-scope="{ row }">
                    <div class="engine-column">
                        <div class="engine-column__version">
                            <p>{{ row.minEngineVersion }}</p>
                            <p>
                                ~{{ row.maxEngineVersion === newestEngineVersion ? '最新版本' : row.maxEngineVersion }}
                            </p>
                        </div>
                        <hc-tooltip
                            class="item"
                            effect="dark"
                            content="该版本与当前工作区引用的引擎版本不兼容！"
                            placement="top"
                        >
                            <span v-show="!canSelected(row)" class="component-item__name--useless" />
                        </hc-tooltip>
                    </div>
                </template>
            </hc-table-column>
            <hc-table-column prop="createdAt" label="创建时间" />
            <hc-table-column prop="description" show-overflow-tooltip label="版本说明" />
            <hc-table-column label="选择" width="80">
                <template slot-scope="scope">
                    <div :class="!canSelected(scope.row) ? 'disabled-radio' : ''">
                        <hc-radio
                            v-model="checkVersion"
                            :disabled="!canSelected(scope.row)"
                            :label="scope.row.version"
                        >
                            {{ '' }}
                        </hc-radio>
                    </div>
                </template>
            </hc-table-column>
        </hc-table>
        <span slot="footer" class="dialog-footer">
            <hc-button size="medium" @click="handleClose">取消</hc-button>
            <hc-button size="medium" type="primary" @click="save">保存</hc-button>
        </span>
    </hc-dialog>
</template>

<script>
import semver from 'semver'

export default {
    name: 'AlterQuotesVersion',
    props: {
        dialogVisible: {
            type: Boolean,
            default: () => false,
        },
        versionData: {
            type: Object,
            default: () => {},
        },
        workspaceEngine: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            checkVersion: '',
            newestEngineVersion: '999999.999999.999999',
        }
    },
    computed: {
        versions() {
            return this.versionData.versions
        },
        title() {
            return `更改${this.versionData.name}版本`
        },
    },
    watch: {
        dialogVisible(val) {
            if (val) {
                const { used, version } = this.versionData
                this.checkVersion = (used && used.version) || version
            }
        },
    },
    methods: {
        handleClose() {
            this.$emit('closeDialog')
        },
        canSelected(item) {
            const currentItem = item
            const engineVersion = this.workspaceEngine
            const { minEngineVersion, maxEngineVersion, canDebug } = currentItem
            // const deps = currnetItem.dependencies
            // const depCanSelected = deps ? deps.every(dep => this.canSelected(dep)) : true
            if (engineVersion === 'nightly' && canDebug) return true
          
            return (
                semver.valid(engineVersion)
              && semver.valid(minEngineVersion)
              && semver.valid(maxEngineVersion)
              && semver.gte(engineVersion, minEngineVersion)
              && semver.lte(engineVersion, maxEngineVersion)
            )
        },
        save() {
            const checkedVersion = this.versions.find(item => item.version === this.checkVersion)
            this.$emit('save', {
                ...checkedVersion,
                name: this.versionData.name,
                id: this.versionData.id,
            })
        },
    },
}
</script>

<style lang="less" scoped>
.engine-column {
  display: flex;
  align-items: center;
  &__version {
      // display: flex;
      font-size: 14px;
      line-height: 14px;
      margin-right: 6px;
  }
}
.disabled-radio {
  pointer-events: none;
}
</style>
